import React, {useState, useEffect} from 'react';
import {Typography, Button, Dialog, Slide, AppBar, Toolbar, DialogContent} from '@material-ui/core/';
import { useStyles } from "./style";
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import modalStyles from 'components/ModalConfirmation/styles';
import { Person } from '@material-ui/icons';
import Cancel from '@material-ui/icons/Cancel';
import FormFirmaElectronica from 'components/FormFirmaElectronica';
import Title from 'components/TitleWithIcon';
import DialogLoadingMessage from 'components/LoadingMessage/index'
import ComparacionDeDatos from '../comparacionDeDatos';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

  let element = 0, idEntrante = '', valorEncontrado = false, RegistrosObtenidos = [];
function CancelarTodosLosCiudadanosAFallecidos(props) {
    const classesModal = modalStyles(),
        classes = useStyles(),
        [mensaje, setMensaje] = useState({tipoError:'', tipoMensaje:''}),
        [open, setOpen] = useState(false),
        [loading, setLoading] = useState(false);

    const SplitNumber = function (data) {
        if (data !== undefined) {
            if (data !== null) {
            var arr1 = data.split("opcion");
            return arr1[1];
            }
        }
        };

    const obtenerTodosLosRegistrosSeleccionadosACancelar = (registroChecked) => {
        for(element =0; element<=RegistrosObtenidos.length; element++){                
            if(registroChecked === 'opcion'+RegistrosObtenidos[element]){
                valorEncontrado = true
                break;
            }else {
                valorEncontrado = false
            }            
        }
        if(!valorEncontrado){
            RegistrosObtenidos.push(Number(SplitNumber(registroChecked)));
        }else{
            idEntrante = RegistrosObtenidos.indexOf(RegistrosObtenidos[element]);
            RegistrosObtenidos.splice(idEntrante,  1);
        }
    }
    const procesarTodosLosRegistrosSeleccionados = (password) => {
        props.buttonProcess(password, RegistrosObtenidos)
    }

    useEffect(() => {
        if(props.open){
            RegistrosObtenidos = []
            let datos = props.datosDelCiudadanoAComparar||[]
            Object.keys(datos).forEach((element, key, _array) =>{
                RegistrosObtenidos.push(datos[element]?.renap?.iddetalle)
            })
        }
    }, [props.open])

    return (
        <div>
            <Dialog     open={props.open}
                        fullScreen 
                        TransitionComponent={Transition}
                        keepMounted
                        onClose={props.closeModal}
                        aria-labelledby="alert-dialog-slide-title"
                        aria-describedby="alert-dialog-slide-description"
            >         
                <AppBar className={classes.appBar} elevation={0}>
                    <Toolbar >
                        <Typography variant="h6" className={classes.title}> Cancelar todos los ciudadanos seleccionados</Typography>          
                        <Button autoFocus color="inherit" onClick={props.closeModal}> Cerrar</Button>
                    </Toolbar>                
                </AppBar>
                <DialogContent className={classes.dialogContent}>
                    <Title title="¿Está seguro de cancelar todos los ciudadanos?" icon={"/assets/iconQuestion.png"}/>
                    {
                        props.open && (
                            <ComparacionDeDatos 
                                datosDelCiudadanoAComparar={props.datosDelCiudadanoAComparar}
                                obtenerTodosLosRegistrosSeleccionadosACancelar={obtenerTodosLosRegistrosSeleccionadosACancelar}
                            />                    
                        )
                    }
                    <FormFirmaElectronica 
                        inputTitleProcess={'Ingrese Contraseña *'}
                        buttonTitleProcess={'Sí, estoy seguro!'}
                        buttonIconProcess={<Person />}
                        buttonProcess={procesarTodosLosRegistrosSeleccionados}
                        // buttonProcess={props.buttonProcess}
                        buttonTitleCancel={'no, cancelar'}
                        buttonIconCancel={<Cancel />}
                        closeModal={props.closeModal}
                    />
                </DialogContent>            
                {/* <DialogLoadingMessage open={props.loading} title={'Cancelando todos los ciudadanos ...'}/> */}
            </Dialog>   
        </div>
    );
}


export default connect(mapStateToProps, mapDispatchToProps)(CancelarTodosLosCiudadanosAFallecidos);